// Realitní kancelář – JS jen vylepšuje: bez něj funguje hledání (GET), galerie (odkazy) i FAQ (details).
import initRoSearchForms from './components/search-form';
import initRoGalleries from './components/gallery';
import initRoParamsToggle from './components/params-toggle';
import initRoMapLock from './components/map-lock';
import initRoDemands from './components/demand-budget';

document.addEventListener('DOMContentLoaded', () => {
  initRoSearchForms(); // hledání v katalogu ([data-ro-search]) – úvod (hero), katalog
  initRoGalleries(); // galerie + lightbox na detailu ([data-ro-gallery])
  initRoParamsToggle(); // více / méně parametrů na detailu ([data-ro-params])
  initRoMapLock(); // zámek mapy na detailu ([data-ro-map])
  initRoDemands(); // poptávky: −/+ a předvolby rozpočtu ([data-ro-demand-budget]), řazení ([data-ro-demand-sort])
});
